import { AddSchema } from "mobx-firelink";
export class Seed {
    constructor(initialData) {
        this.Extend(initialData);
    }
}
AddSchema("Seed", {
    properties: {
        book: { $ref: "UUID" },
        text: { type: "string" },
        attributeLevels: { $ref: "AttributeLevels" },
    },
});
